import React, {useEffect} from 'react'
import styled from 'styled-components'
import Footer from '../Footer'
import Header from '../Header'


function BlogDetails() {

    useEffect(()=>{
        window.scrollTo(0,0)
      },[])

    return (
        <>
            <Header/>
            <Banner>
                <div className="banner__container">
                    <div className="banner__content">
                        <h2>Blog Details</h2>
                        <p>We are committed to keeping you updated on the latest trends of business.</p>
                    </div>
                    <div className="banner__background"></div>
                </div>
            </Banner>
            <Container>
               <Stories>
                    <BlogPost>
                        <div className="blog__image">
                            <img src="https://templates.envytheme.com/finix/default/assets/img/blog/image4.jpg" alt="Blog" />
                            <div className="blog__caption">
                                <Date>
                                <i class="fa fa-calendar" aria-hidden="true"></i>
                                    July 05, 2021
                                </Date>
                                <Author>
                                    <i class="fa fa-user" aria-hidden="true"></i>
                                    Admin
                                </Author>
                            </div>
                        </div>
                        <div className="blog__content">
                            <Title>Financing loans available to small businesses</Title>
                            <Description>
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore dolore magna aliqua. Quis ipsum suspendisse ultrices gravida. Risus commodo viverra maecenas accumsan lacus vel facilisis. At vero eos et accusam et justo duo dolores et ea rebum.
                                <br/>
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore dolore magna aliqua. Quis ipsum suspendisse ultrices gravida. Risus commodo viverra maecenas accumsan lacus vel facilisis. At vero eos et accusam et justo duo dolores et ea rebum.
                                <br/>   
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore dolore magna aliqua. Quis ipsum suspendisse ultrices gravida. Risus commodo viverra maecenas accumsan lacus vel facilisis. At vero eos et accusam et justo duo dolores et ea rebum.

                                <SubTitle>Types of small business loans</SubTitle>
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore dolore magna aliqua. Quis ipsum suspendisse ultrices gravida. Risus commodo viverra maecenas accumsan lacus vel facilisis. At vero eos et accusam et justo duo dolores et ea rebum.

                                <SubTitle>Other financing options</SubTitle>
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore dolore magna aliqua. Quis ipsum suspendisse ultrices gravida. Risus commodo viverra maecenas accumsan lacus vel facilisis. At vero eos et accusam et justo duo dolores et ea rebum.
                                <br/>
                                Quis ipsum suspendisse ultrices gravida. Risus commodo viverra maecenas accumsan lacus vel facilisis. At vero eos et accusam et justo duo dolores et ea rebum.

                            </Description>
                        </div>
                    </BlogPost>
                </Stories> 
                {/* Categories Section (aside section) */}
                
                <aside>
                    <Categories>
                        <h3>Categories</h3>
                        <ul>
                            <li>Agricultural Loan</li>
                            <li>Business Loan</li>
                            <li>House Loan</li>
                            <li>Personal Loan</li>
                            <li>Education Loan</li>
                            <li>Payday Loan</li>
                            <li>Vehicle Loan</li>
                            <li>Medical Loan</li>
                            <li>Startup Loan</li>
                        </ul>
                    </Categories>
                    <RecentPosts>
                        <h3>Recent Posts</h3>
                        <div className="post">
                            <img src="/images/post/post_6.png" alt="" />
                            <div className="post__caption">
                                <h4>Customer experience</h4>
                                <span>06-07-2021</span>    
                            </div>   
                        </div>
                        <div className="post">
                            <img src="/images/post/post_1.png" alt="" />
                            <div className="post__caption">
                                <h4>Start up loans </h4>
                                <span>07-07-2021</span>    
                            </div>   
                        </div>
                        <div className="post">
                            <img src="/images/post/post_8.png" alt="" />
                            <div className="post__caption">
                                <h4>Eligibility and criteria </h4>
                                <span>06-08-2021</span>    
                            </div>   
                        </div>
                    </RecentPosts>
                </aside>
            </Container>

            <Footer/>
        </>
    )
}


const Container = styled.div`
    padding: 50px 10px;
    background: rgb(251, 251, 251);

    @media(min-width: 992px){
        display: flex;
        padding: 50px;
        justify-content: space-between;
    }

    aside{
        @media(min-width: 992px){
            width: 30%;
        }
    }

`
const Stories = styled.div`
    display: flex;
    flex-direction: column;
    background: rgb(255, 255, 255);
    padding-bottom: 50px;

    @media(min-width: 992px){
        width: 65%;
        background: inherit;
    }

    
`

const BlogPost = styled.div`
    div.blog__image img{
        width: 100%;
    }
    margin-bottom: 50px;
`
const Title = styled.div`
    font-size: 28px;
    line-height: 26.4px;
    font-weight: 500; 
    margin: 20px 0;
`

const Description= styled.div`
    font-size: 16px;
    line-height: 28.8px;
    color: rgb(96, 96, 96);
    margin-bottom: 20px;


`
const SubTitle = styled.div`
    font-size: 28px;
    line-height: 26.4px;
    font-weight: 500; 
    margin: 20px 0;
    color: rgb(17, 17, 17);
`

const Author =  styled.span`
    i{
        color: rgb(231, 60, 62);
        margin-right: 10px;
    }
    
    font-size: 13px;
    font-weight: 500;
    color: rgb(96, 96, 96);
    margin-right: 20px;
`

const Date = styled(Author)``

const Banner = styled.div`
    .banner__container{
        color: rgb(255, 255, 255);
        display: flex;
        flex-direction: column;
        z-index: 1;
        position: relative;
        background: black;
        overflow: hidden;

        p{
            color: rgb(255, 255, 255);
        }
    }

    .banner__background{
        background: linear-gradient(rgba(0,0,0,0.3),rgba(0,0,0,0.3)), url("/images/gallery/about1.jpg");
        background-size: cover;
        background-position-x: center;

        background-attachment: fixed;
        position: absolute;
        opacity: 0.3;
        top: 0;
        height: 100%;
        width: 100vw;
        z-index: -1;

    }
    
    .banner__content{
        color: rgb(255, 255, 255);
        max-width: 80%;
        padding: 10% 20px;
        p{
            color: rgb(255, 255, 255);
        }
    }
    
`


const Categories = styled.div`
    background: rgb(255, 255, 255);
    padding: 20px;
    margin-top: 50px;
    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;

    @media(min-width: 990px){
        margin-top: 0;
    }

    h3{
        border-bottom: 1px solid rgb(231, 60, 62);
        padding-bottom: 10px;
        font-weight: 400;
    }

    ul{
        list-style-type: none;
        padding-left: 0;
        
        li{
            padding: 10px 0;;
            border-bottom: 1px solid rgb(231, 231, 231);
            cursor: pointer;
            transition: 0.5s ease;

            :hover{
                color: rgb(231, 60, 62);
                font-size: 17px;
            }
        }
        
        li:last-child{
            border-bottom: none;
        }
    }
`

const RecentPosts = styled.div`
    background: rgb(255, 255, 255);
    padding: 20px;
    margin-top: 50px;
    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;

    h3{
        border-bottom: 1px solid rgb(231, 60, 62);
        padding-bottom: 10px;
    }
    .post{
        display: flex;
        margin-bottom: 20px;

        img{
            width: 20%;
            cursor: pointer;
        }
        
        .post__caption{


            margin-left: 20px;
            h4{
                line-height: 0;
                cursor: pointer;
                transition: 0.2s ease;

               
            }
            h4:hover{
                color: rgb(231, 60, 62);
            }
            span{
                font-size: 14px;
            }
        }
        

    }


`
export default BlogDetails
